export const GET_DATA = 'requirementLaborResources/GET_DATA'
export const GET_DATA_DONE = 'requirementLaborResources/GET_DATA_DONE'
export const GET_DATA_FAIL = 'requirementLaborResources/GET_DATA_FAIL'

export const GET_CALCULATOR = 'requirementLaborResources/GET_CALCULATOR'
export const GET_CALCULATOR_DONE = 'requirementLaborResources/GET_CALCULATOR_DONE'
export const GET_CALCULATOR_FAIL = 'requirementLaborResources/GET_CALCULATOR_FAIL'
export const GET_CALCULATOR_RESET = 'requirementLaborResources/GET_CALCULATOR_RESET'

export const GET_CROP_RAI = 'requirementLaborResources/GET_CROP_RAI'
export const GET_CROP_RAI_DONE = 'requirementLaborResources/GET_CROP_RAI_DONE'
export const GET_CROP_RAI_FAIL = 'requirementLaborResources/GET_CROP_RAI_FAIL'

export const GET_CROP_REGION = 'requirementLaborResources/GET_CROP_REGION'
export const GET_CROP_REGION_DONE = 'requirementLaborResources/GET_CROP_REGION_DONE'
export const GET_CROP_REGION_FAIL = 'requirementLaborResources/GET_CROP_REGION_FAIL'